module.exports = __webpack_public_path__ + "images/img-3bohH_0.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/keitaro-integration/en/6.png
// module id = 2342
// module chunks = 0